export default "__VITE_ASSET__DYlaoe2G__"